import { useEffect, useState } from "react";
import { ProjectsHeader } from "../../components/Projects/ProjectsHeader";
import "./ProjectsPage.css";
import { message } from "antd";
import { useGetProjectsQuery } from "../../store/api/lumi/projects";
import { ProjectsActionsComponent } from "../../components/Projects/ProjectsActionsComponent";
import { ProjectsList } from "../../components/Projects/ProjectsList";
import { useGetUserProfileQuery } from "../../store/api/lumi/auth";

export function ProjectsPage() {
    const token = localStorage.getItem('lumitoken');
    const { data, isSuccess, isLoading } = useGetUserProfileQuery({  skip: token});
    const [currentWorkspace, setCurrentWorkspace] = useState(() => {
        const savedWorkspace = localStorage.getItem("default_workspace");
        return savedWorkspace ? savedWorkspace : "loading";
    });
    const { data: projects, isLoading: isProjectsLoading } =
        useGetProjectsQuery();
    const [page, setPage] = useState(0);
    const [perPage] = useState(10);
    const [startIndex, setStartIndex] = useState(0);
    const [endIndex, setEndIndex] = useState(perPage);
    const [searchQuery, setSearchQuery] = useState("");
    const [messageApi, contextHolder] = message.useMessage();
    const [sortBy, setSorting] = useState("creation_date desc");

    // This useEffect hook updates local storage when currentWorkspace changes
    useEffect(() => {
        localStorage.setItem("default_workspace", currentWorkspace);
    }, [currentWorkspace]);

    const handleWorkspaceChange = (value) => {
        setCurrentWorkspace(value);
    };

    useEffect(() => {
        if (isProjectsLoading) {
            messageApi.open({
                type: "loading",
                content: "Loading projects...",
                duration: 0,
            });
        } else {
            messageApi.destroy();
        }
    }, [isProjectsLoading]);

    useEffect(() => {
        setStartIndex(page * perPage);
        setEndIndex(startIndex + perPage);
    }, [page, perPage, startIndex]);

    useEffect(() => {
        if (searchQuery === "") {
            setStartIndex(page * perPage);
            setEndIndex(startIndex + perPage);
        } else {
            setStartIndex(0);
            setEndIndex(projects ? projects.length : 0);
        }
    }, [searchQuery]);

    return (
        <>
            <ProjectsHeader name={data?.username}/>
            <div className="container">
                {contextHolder}
                <div className="projects-section">
                    <ProjectsActionsComponent
                        handleWorkSpaceChange={handleWorkspaceChange}
                        currentWorkspace={currentWorkspace}
                        setSearchQuery={setSearchQuery}
                        searchQuery={searchQuery}
                        setSortBy={setSorting}
                        sortBy={sortBy}
                        data={data}
                        isSuccess={isSuccess}
                        isLoading={isLoading}
                    />

                    <ProjectsList
                        searchQuery={searchQuery}
                        currentWorkspace={currentWorkspace}
                        sortBy={sortBy}
                    />
                </div>
            </div>
        </>
    );
}
